import { Link, Outlet, useMatch } from 'react-router'
import { Logo } from '@/shared/ui/Logo'
import { ProfileMenu } from '@/features/auth/ProfileMenu'
import { ROUTES } from '@/shared/routes'
import { useDashboardFilters } from '@/features/dashboard/filters/useDashboardFilters'
import { ViewModeSelect } from '@/features/dashboard/filters/ViewModeSelect'
import { ThemeToggle } from '@/shared/ui/ThemeToggle'
import styles from './AppShell.module.css'

export const AppShell = () => {
  // The view mode sits at the header's far right, on the home dashboard only.
  const isHome = useMatch(ROUTES.HOME) !== null
  const { viewMode } = useDashboardFilters()
  const showViewMode = isHome && viewMode !== undefined
  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <div className={styles.bar}>
          <Link to={ROUTES.HOME} className={styles.brand}>
            <Logo className={styles.logo} />
            <span className={styles.name}>Dashboard</span>
          </Link>
          <div className={styles.right}>
            {showViewMode && (
              <>
                <ViewModeSelect />
                <div className={styles.divider} aria-hidden='true' />
              </>
            )}
            <div className={styles.actions}>
              <ProfileMenu />
              <ThemeToggle />
            </div>
          </div>
        </div>
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  )
}
